import { useCallback, TouchEvent, KeyboardEvent } from 'react'

import { useDispatch } from 'react-redux'
import { useTheme } from 'styled-components'

import { goBackAction } from 'actions/route/routeAction'
import { KEY_CODE } from 'common/constants'
import { PlatformType } from 'common-constants/bowser'
import { NumberDirection } from 'common-constants/numbers'
import { clientThrottle } from 'functions/performance'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'
import { useWindowEvent } from 'hooks/useWindowEvent'

export const usePhotoViewerSettings = (
  handleScrollToNextPhoto: (direction: number) => void
) => {
  const { platformType } = useShallowEqualSelector(
    ({ systemReducer: { platformType } }) => ({
      platformType,
    })
  )
  const { multiplier } = useTheme()

  const dispatch = useDispatch()

  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {
      if (event.keyCode === KEY_CODE.LEFT_ARROW) {
        handleScrollToNextPhoto(NumberDirection.left * multiplier)
      }
      if (event.keyCode === KEY_CODE.RIGHT_ARROW) {
        handleScrollToNextPhoto(NumberDirection.right * multiplier)
      }

      if (
        event.keyCode === KEY_CODE.ESCAPE ||
        event.keyCode === KEY_CODE.UP_ARROW ||
        event.keyCode === KEY_CODE.DOWN_ARROW
      ) {
        dispatch(goBackAction())
      }
    },
    [dispatch, handleScrollToNextPhoto, multiplier]
  )

  const disableScroll = useCallback(
    (event: TouchEvent) => {
      const isTouch =
        PlatformType.Mobile === platformType ||
        PlatformType.Tablet === platformType
      if (event.cancelable && isTouch) {
        event.preventDefault()
      }
    },
    [platformType]
  )

  useWindowEvent('keydown', clientThrottle(handleKeyDown, 100, true))

  useWindowEvent('touchmove', disableScroll, {
    passive: false,
  })
}
